'use strict';

const $ = jQuery.noConflict();

$(function() {

	const tabsBlock = {

		mobileBp: 767,
		offsetTop: 120, // header + malo prostora

		init: function() {
			this.cacheDOM();
			if (!this.$section.length) return;

			this.bindEvents();
			this.updateActiveOnScroll();
		},

		cacheDOM: function() {
			this.$window = $(window);
			this.$section = $('.js-tabs-block');
			this.$panels = this.$section.find('.js-tab-panel');
			this.$navItems = this.$section.find('.js-tab-item');
		},

		isMobile: function() {
			return window.innerWidth <= this.mobileBp;
		},

		bindEvents: function() {
			this.$navItems.on('click', this.onNavClick.bind(this));
			this.$window.on('scroll.tabsBlock', this.updateActiveOnScroll.bind(this));
		},

		onNavClick: function(e) {
			e.preventDefault();

			const $item = $(e.currentTarget);
			const idx = this.$navItems.index($item);
			const $target = this.$panels.eq(idx);

			if (!$target.length) return;

			const targetY = $target.offset().top - this.offsetTop;

			$('html, body').stop().animate({
				scrollTop: targetY
			}, 500);
		},

		updateActiveOnScroll: function() {
			const scrollY = window.scrollY + this.offsetTop + 140;

			let activeIdx = 0;

			this.$panels.each(function(i) {
				if ($(this).offset().top <= scrollY) {
					activeIdx = i;
				}
			});

			this.$navItems.removeClass('is-active').eq(activeIdx).addClass('is-active');
		}
	};

	tabsBlock.init();

});